
import React from "react";
import SupplyItem from "./SupplyItem";
import { CraftSupply } from "./types";

interface SuppliesListProps {
  supplies: CraftSupply[];
  onToggleSupply: (id: string) => void;
  onRemoveSupply: (id: string) => void;
  defaultSupplyIds: string[];
}

const SuppliesList: React.FC<SuppliesListProps> = ({ 
  supplies, 
  onToggleSupply, 
  onRemoveSupply,
  defaultSupplyIds
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      {supplies.map((supply) => (
        <SupplyItem 
          key={supply.id} 
          supply={supply} 
          onToggle={onToggleSupply} 
          onRemove={onRemoveSupply}
          isDefaultSupply={defaultSupplyIds.includes(supply.id)}
        />
      ))}
    </div>
  );
};

export default SuppliesList;
